export const createState = () => ({
    id: '',
    title: '',
    kind: 'general',
    published: null,
    body: '',
    synopsis: '',
    is_pinned: false,
});
